/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Eyebrow_PricingInputs */

const en_directory_ai_tools_eyebrow_pricing = /** @type {(inputs: Directory_Ai_Tools_Eyebrow_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing`)
};

const zh_directory_ai_tools_eyebrow_pricing = /** @type {(inputs: Directory_Ai_Tools_Eyebrow_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格`)
};

/**
* | output |
* | --- |
* | "Pricing" |
*
* @param {Directory_Ai_Tools_Eyebrow_PricingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_eyebrow_pricing = /** @type {((inputs?: Directory_Ai_Tools_Eyebrow_PricingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Eyebrow_PricingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_eyebrow_pricing(inputs)
	return zh_directory_ai_tools_eyebrow_pricing(inputs)
});
export { directory_ai_tools_eyebrow_pricing as "directory.ai_tools.eyebrow.pricing" }